<template>
  <div class="w-full overflow-hidden space-y-5">
    <div class="flex justify-between">
      <div class="space-x-2">
        <base-button small @click="toggleAllRows">{{ checkedRows.length ? 'Uncheck All' : 'Check All' }} Rows</base-button>
        <base-button small @click="toggleAllCols">{{ checkedCols.length ? 'Uncheck All' : 'Check All' }}  Columns</base-button>
      </div>
      <div class="flex gap-2">
        <base-tooltip>
          <template v-slot:content>
            <span class="block w-56">This indicates that the row or column is not present in the database being imported. This will not delete what exists on the current database.</span>
          </template>
          <span class="block w-4 h-4 bg-red-500 border border-red-700"></span>
        </base-tooltip>
        <base-tooltip>
          <template v-slot:content>
            <span class="block w-56">This indicates that the row or column is not present in the current database. This will be imported.</span>
          </template>
          <span class="block w-4 h-4 bg-green-500 border border-green-700"></span>
        </base-tooltip>

        <base-tooltip>
          <template v-slot:content>
            <span class="block w-56">This indicates that the data differs between the current database and the importing database. This data will only be updated if the updated_at column is newer on the importing database unless you do a force import.</span>
          </template>
          <span class="block w-4 h-4 bg-yellow-500 border border-yellow-700"></span>
        </base-tooltip>
      </div>
    </div>
    <div class="overflow-x-auto overflow-y-visible">
      <table class="divide-y divide-gray-300">
        <thead>
          <tr class="divide-x divide-gray-200">
            <!-- TODO: Add select all rows and select all cols in first heading col -->
            <th v-if="allowSelect" scope="col" class="py-3.5 px-2 text-left text-sm font-semibold text-gray-900 opacity-0">Select</th>
            <th v-for="(col, idxC) in cols" :key="`${uuid}-col-${idxC}`" scope="col" class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
              <p class="flex flex-col gap-2 flex-nowrap items-start">
                <span><input type="checkbox" :name="`${uuid}-checkedcols`" v-model="checkedCols" :value="idxC" /></span>
                <span>{{ col }}</span>
              </p>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="(row, idxR) in rows" :key="`${uuid}-row-${idxR}`" v-show="!showOnlySelected || (showOnlySelected && checkedRows.includes(idxR))" :class="`divide-x divide-gray-200 ${delRowIds.includes(row.id) ? 'bg-red-500 text-red-50' : (newRowIds.includes(row.id) ? 'bg-green-500 text-green-50' : 'text-gray-500')}`">
            <td v-if="allowSelect" class="whitespace-nowrap py-4 px-2 text-center"><input type="checkbox" :name="`${uuid}-checkedrows`" v-model="checkedRows" :value="idxR" :disabled="delRowIds.includes(row.id)" class="disabled:opacity-30 disabled:cursor-not-allowed" /></td>
            <!-- <td class="whitespace-nowrap p-4 text-sm font-medium text-gray-900">row.id</td> -->
            <td v-for="(col, idxC) in cols" :key="`${uuid}-row-${idxR}-col-${idxC}`" :class="`whitespace-nowrap p-4 text-sm max-w-96 truncate ${diffData[row.id] && diffData[row.id].includes(col) ? 'bg-yellow-500 text-yellow-50' : ''}`" @click="showDiff(row, col)">{{ row[col] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      showOnlySelected: false
    }
  },
  props: {
    allowSelect: false,
    value: {
      type: Object,
      default: () => {
        return {
          cols: [],
          rows: [],
        }
      }
    },
    rows: {
      type: Array,
      default: () => [],
    },
    cols: {
      type: Array,
      default: () => [],
    },
    newCols: {
      type: Array,
      default: () => [],
    },
    delCols: {
      type: Array,
      default: () => [],
    },
    newRows: {
      type: Array,
      default: () => [],
    },
    delRows: {
      type: Array,
      default: () => [],
    },
    diffData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    checkedRows: {
      get() {
        return this.value.rows
      },
      set(val) {
        this.$emit('input', {cols: this.value.cols, rows: val})
      }
    },
    checkedCols: {
      get() {
        return this.value.cols
      },
      set(val) {
        this.$emit('input', {cols: val, rows: this.value.rows})
      }
    },
    delRowIds() {
      return this.delRows.map(r => r.id);
    },
    newRowIds() {
      return this.newRows.map(r => r.id);
    },
  },
  methods: {
    //
    toggleAllRows() {
      //
      if (this.checkedRows.length) {
        this.$emit('input', {cols: this.value.cols, rows: []});
      } else {
        this.$emit('input', {cols: this.value.cols, rows: Array.from({ length: this.rows.length }, (value, index) => index)});
      }
    },
    toggleAllCols() {
      //
      if (this.checkedCols.length) {
        this.$emit('input', {cols: [], rows: this.value.rows});
      } else {
        this.$emit('input', {cols: Array.from({ length: this.cols.length }, (value, index) => index), rows: this.value.rows});
      }
    },
    showDiff(row, col) {
      if (this.diffData[row.id] && this.diffData[row.id].includes(col)) {
        this.$swal.fire({
          title: 'Data Differences',
          html: `<div class="flex gap-4"><div><p>Current Database:`
        });
      }
    },
  },

}
</script>
